import { prepareFormData } from '@/store/utils/formDataHelper';
import { Action, getModule, Module, MutationAction, VuexModule } from 'vuex-module-decorators';
import store from '@/store'
import { IClientsCategories, IClientsCategoriesListItem, ClientsCategoriesResponseType } from '@/entity/clients/clientsCategories.types';
import { PaginationRequestType } from '@/entity/common/pagination.types'
import { ClientsCategoriesRequestType } from '@/form/Settings/categories/clients.types';

import { ResponseDataType } from '@/form/form.types'
@Module({
    namespaced: true,
    name: 'clientCategories',
    store,
    dynamic: true
})
class ClientsCategoriesSettingsModule extends VuexModule {
    clientCategories: IClientsCategories | null = null;
    clientCategory: IClientsCategoriesListItem | null = null;
    clientCategoriesLoaded = false;
    clientCategoryLoaded = false;
    @MutationAction
    async fetchAll(data?: PaginationRequestType): Promise<{ clientCategories: IClientsCategories; clientCategoryLoaded: boolean }> {
    
        let clientCategoryLoaded = false;
        console.log('Client category settings query vuex - ')
        const clientCategories = await store.$repository.clientsCategories.fetchAll(prepareFormData(data));
        console.log('Client category settings query vuex - ')
        console.log(clientCategories);
        if (clientCategories) {
            clientCategoryLoaded = true;
        }
        return { clientCategories, clientCategoryLoaded };
    }
    @MutationAction
    async fetchData(data: PaginationRequestType): Promise<{ clientCategory: IClientsCategoriesListItem; clientCategoryLoaded: boolean }> {
        console.log('Client query vuex fetch Data - ')
        let clientCategoryLoaded = false;
        const clientCategory = await store.$repository.clientsCategories.fetchData(data);
        if (clientCategory) {
            clientCategoryLoaded = true;
        }
        return { clientCategory, clientCategoryLoaded };
    }
    @Action({ rawError: true })
    async create(data: ClientsCategoriesRequestType): Promise<boolean> {
        return await store.$repository.clientsCategories.create(data);
    }
    @Action({ rawError: true })
    async update(data: ClientsCategoriesRequestType): Promise<ResponseDataType> {
        return  await store.$repository.clientsCategories.update(data);
    }
    @Action({ rawError: true })
    async delete(data: { id: number }): Promise<ResponseDataType> {
        return await store.$repository.clientsCategories.delete(data);
    }
}

export const ClientsCategoriesSettingsStore = getModule(ClientsCategoriesSettingsModule);
